import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=0351597e&scoped=true&"
import script from "./NumberInput.vue?vue&type=script&lang=ts&"
export * from "./NumberInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0351597e",
  null
  
)

export default component.exports